/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyOBUType
 */
export interface ReadOnlyOBUType {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyOBUType
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyOBUType
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyOBUType
     */
    name: string;
}

export function ReadOnlyOBUTypeFromJSON(json: any): ReadOnlyOBUType {
    return ReadOnlyOBUTypeFromJSONTyped(json, false);
}

export function ReadOnlyOBUTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyOBUType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'name': json['name'],
    };
}

export function ReadOnlyOBUTypeToJSON(value?: ReadOnlyOBUType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


